import { sha1 } from "js-sha1";

const forbiddenWords = [
  "c6b77346f7d33fb4785d55f942f1101828334c77",
  "d6aba4bb90fbb4f0cfa33b81c5dbd1f31ec98ced",
  "96d5c25df07378af1defb2e205ed5de0a384ad7a",
  "2fdeb850e2ce5400f5624c511222029eb09f6e34",
  "6a7f84c9bac203adef593ff3bff10c3b2e1bc59e",
  "aa32256fa16aa4adbb5ce999744fc8773d7cc2fe",
  "b5f2adc51525589238df25e3e8604853950bde14",
  "b2c81be7d9feb7a908b25043e0d0101b08983ac8",
  "03154ff3213b96ca885d21d5d9e89e233d19309c",
  "8056a7c010088050a8b61322b7d4e3348c5d8b4c",
  "5c2774d6038636f43b19c7dc59fcf68729c81ea4",
  "3ba79bfab5463a5165f826a2e13cd0c22bf167b0",
  "01c2f77874fefdaac2dd2ba53cbadba42110342f",
  "8d096eeb7a0b7fb99f8ccdb59f90b2368f782883",
  "b7217b982e4dc469b928f52dbc433c839273066d",
  "e4ab0a66a299655393b257f747198b3255af1796",
  "509e5dd869339042ac5ae70baebb53d3cc1fbee6",
  "3a6e8a1a0d8c3510de63536820ce3410fbec2047",
  "20817292c3bd03abe80ec7906f14594649e66632",
  "508246108b74032ce2136f4c41469af4b67f6319",
  "3a01c29238f2f6080a531eb3f40d210f43bd05a3",
  "bf09abc085e6d798152c812c3bbf3486bdfc1499",
  "fbdadd02f904f2886c8682fc99a4c1008897aff0",
  "115119badb9db78468e4b1f19577e82ccdc9ec4c",
  "8cba50f7305f61afde6b76f39147d6ece033a802",
  "2deefed596ce8237ca58690439ef53e6e68f51c3",
  "556c78a8b8c9dcff55c9db64805810d2e4ef3e9a",
  "0089a873d73542cf3d588ba3bdae1811990dce51",
  "044eedd5277e2b952d2867fa07e6a6bdc055c2be",
  "174d76aaf9062810d4b866ef640a12a0b857469c",
  "b2c9779282ea9a8222e3f10f9acbba1d0fc56d93",
  "5cc4b4f8c2ea78d2abcb2f6857b05162451282d6",
  "97e4f80039852abdd6e93f726315537bd54bf054",
  "d65a0b2fa601df58658da0405364883aee5d14b9",
  "1f721b9ce0247827d66b94fbb81385855d90eb2c",
  "0ae4ff1d43ed3959d7ee096dc2a16434cedfa664",
  "623dc06d57a120cd951e408dd37ef284e4fa4113",
  "150f9c6f3b7f0ac3c5b92a96b24c5b8bde5b164c",
  "0f3a5609e4a63c1e059f8c8785d6ee06b17a0cdf",
  "3e3209e713c422f5307e884e9b4f7e77bbe0f243",
  "f32e05b3a9d2845d7d918745f972a7477e01c37a",
  "44230ca2e10b5742a049e9e88ae47b1ba33a9375",
  "684264eaed7c37235d99dc0d3e3ef74846913951",
  "1ef31f3c9495b3086431ad061ae9a5c8cb279ded",
  "b0680b310bf8c91841331afa9635514fc3756001",
  "55231d26098c515b9d37c3389f74d5ea6edd9733",
  "db1c5e45a291f7bb48bc82440ccdca9acced0ef7",
  "c642c2a8e37d189116334cc4692ca312dfb4ab51",
  "32dc3776678be492231cf61a368b6cb11606a183",
  "73bf738a4120cdc08825dcbbe087278d60bc2ccc",
  "2029df17aec91fccad91b9dea8bded20257cd6f1",
  "d32bf680d310fe1427a7ad97ed6c0434d2fdd076",
  "4da94b60cd0ff487a262ee790037c973072decb3",
  "f8f34030e74bd0ab091a70b6f1a4d9c26ef2d4c2",
  "48d4fecb834d52458d2a1bd573d219cc2f462b07",
  "b6e6e4549b5b5a41efcf37f7ef318ba7d9f59f38",
  "83a18a85b04fbb748912fc3e0296ecc533daa657",
  "692f90dfe399f87e134c53999a1adff3069734c6",
  "67c7b31dafab3752bbfc95e657e7935f559dfd2d",
  "5408a85b9137c062a855161de58d1e061c0b88de",
  "2447479601dfd051a928004696ece026378e77ae",
  "77b666406067a599e3dd493d1ce970cee511ba23",
  "729ca7b3251756440c0cf03821030d5c05440cf7",
  "3f21c36a8e7476c2187b63ba4840fc07829c94c8",
  "a4342ac8f210b04e7ad975f8a979200fc1fe859e",
  "9af7b796ce451a1ae9f8efe2e9cfecc260bc0b6c",
  "0b6a049fa647adad893de005dc7bfe0ec0316f7f",
  "f677e68001dec16eb13c902e8bf618cddfb17edb",
  "cae28f0616ea0f557447fa272683150bb31c934e",
  "b06136815f36bf85da211be099d993f47f253214",
  "c0f286afe8e519ac0cc1a181cee982f48e10bcb6",
  "12d036da8cca30f12890363ecc419c7dfb405f4a",
  "058ac0dec7bb532d7fb88f3a59bf65fd61bc85f3",
  "3a7c37e35fb2b8138b37eae12aae977f7035750f",
  "9c27d2d752d670208efed7e2101b2b0e97bd122f",
  "005dc71f7842e2744d3c908dcd8643a877798afd",
  "27821427335c824255e3fb12f313c471c5c53851",
  "4624dede6de50b36ff9e4ddd169524c2d807a0dc",
  "ab96b61b9b26f52abcf5c7c202be6f2e628e749a",
  "2dfc86064c661aab0a5b4bcf0f4f2bfaa7a0339b",
  "627b8564356941c56347acf891a5b24297a8e570",
  "10b1bcc141da4f9326113ef3cc189f79f8edc7e4",
  "36058f2c09691a7c4b8f325e4be9fcf97db77b00",
  "1eba89c4a0dca3e8f41b43125c5124de8eff7466",
  "057c6f27c9fdf39f8eb758cc35016b8fd596018e",
  "398b6f8f844cb67755f9e19dd87de6e4d54c6f9f",
  "2d72dbfe7080d99926ab7b2b12c33fd86cac07a4",
  "98db153e11ecc03c4832a0fe90c06d199b609fb8",
  "e51e000a893f8123906d0cffa4ddae46b4f73c5b",
  "9f3e110d62d266643d46c853ffb1bf2ea129e8da",
  "a4444d5922e81256817e75fb5657999afdedda48",
  "de90c9ddd6572c80e314dda5e109bfec634f63ba",
  "f65d6e5ebe56107c0d69dd43e4881bee7df12b62",
  "fdae2fb6cd56e039efe08e023f80ee8b54fe669c",
  "33ac980ba895fb0cd7f75a65e30711562f47170f",
  "595106efda3901aed75544a1f821be1f1829a3b7",
  "533e7bdfe52e25b1dcd6b6e01c609f92740737ae",
  "de1903d0c9da0b7b026b87831a3175f71159c3cc",
  "6198bb1ff905aba1fad7def4cf2ee74057705526",
  "9ee77d22f59888d6e51915eadf2b6abeff4919ce",
  "a5acfb3d2815dc85a7a9da76754911b2210049c9",
  "f4b4f580381a6ab680a209130a8476f8ff02583d",
  "dc520726b27227e29bcf3ad438aceb8ce4718c7c",
  "3c2e6ec9d61627fa5b4ec72f85b9cc75fae72cad",
  "9563bf50c23b2d0250bf836ffbc9ed419bac9c90",
  "983b538ad33e3aa23b2b42829de5f28b8054d18c",
  "37ca477cbeb978aa892c55e76aa1344fa29265ad",
  "e430245bab5b7f6926c47a9354dab9b9a2b34c2d",
  "a6e0392df3f480ad5533fc0e4eaf3ad492e14f84",
  "89cb40d90a94bd686e355cd8f81e9c4cc91f563d",
  "ed208f71c3ed4490f17b334dd063a02ef5159565",
  "6fe6f0ed6d22c65cae85ebd92083d457c53808a6",
  "1ecce8f798b3a243494dddc968cab915ae63a97c",
  "5e396da686880634bcf9c7d9ad0f0c58fe462e26",
  "bc7632bf73382dc7ebd79155f695916be30a6a46",
  "4976fc98697cd708e4eff22d73b93d4f25556286",
  "26ac22446aba08dbb482589b023177db22fd9a42",
  "2af0c1aca2a16b60bb04d9dd2061676911415f52",
  "981df672f358f450a6349bfa052d2db45653c204",
  "851660d4e7b0257d6ee0997bc0a4c3bce5f7fe7f",
  "4471a4e754132250f41e1a5d656de037b9acd38f",
  "c986283678e5281ae0aa9edf4d567ccf07a13425",
  "9081a257d1a09346906b6eb7961c2e30ae01c738",
  "cca64d4173e7f3f97f729768c4547e5e2afca5b1",
  "72ca14114acde16b22a436a48d2a97fc30a015f4",
  "d8a9490b17521bb7ae78b026445c4008ba5a3fe3",
  "a68a01530bca1dbd1476664cb53403806c903f50",
  "28d506fa318596c4ea5b1f94d95f7ca01424c69a",
  "dbc2733527da88be4338f72d4da5ae6edf46b627",
  "0a49d18c5e07fe93470772f7979450516e6db836",
  "fea42508b5c27a7f9ae3d2b939adf1b8178a80f9",
  "8d045c587286386d5ca3a4541ad45556eb36b0eb",
  "f2d9d005b2fe78ac5fc49b57bee77ac00026fa53",
  "b6f4b7e12c2517189f4622998c6a2a64314f7b9e",
  "0ee93e90cf8c56e926947b4075513ff57300522c",
  "25e96dc8038b0155f11fdcf5aa515d7b2eb4924e",
  "ce6c56749b2a4c35f875a2a59a0670aa4e7f95ed",
  "2bb3ba5dfda1fa285ef78890dbe9710ad2176b28",
  "bace3b3aa8dbc0171feebfc90306fab98bba18de",
  "da900e40af983634ef80788663fd4cbbc8487aec",
  "83d17adf728aeda5e58070ea0d20d73e65965d48",
  "02de21340c6a5b745873f238431f92b2b38f4e40",
  "18b258e147ed940b3d106a641095da76c3ed3939",
  "3e3f65cb367f5e31a6c88d26fa9b717d696bc8ba",
  "843979d3600e0955eab30f66a92a51079533d9bd",
  "2cef4661be276ee3968f3d2fb8d3a07a53f8c203",
  "c2e7b3845b790c4a5f32029e451f79a074ff65c1",
  "0d14fcedb5ae30c122ea1b11f46ae6a21d5746f0",
  "9c71c2d0193830e92959df9f3d74026a0c9997ed",
  "60971a88e61f2e04931f6ebf78cc0677f4e9a9a6",
  "79109f6ec12878ab2c2e9e055c5eed78cc2116d3",
  "b9de74118cfb73ab1605141de07a6873c98dddf2",
  "a12d4a7144aa47e9b44eef08055ea7c1af24ea83",
  "a59073ffc4d170ffa610602cd61bad4f7aacedec",
  "4b78f33ecfc8066d589e6106b3744f50b98dc437",
  "b03b2bf0bebd3d8f566bb4a0a734e98b752a9827",
  "1f3fe131894444a08a8fa3d69aca9c3e13f4942e",
  "2fc7d710df557c4ddcc23fe112c2537a6bef580c",
  "44105c1739b6972db0a75576791900a532326238",
  "a030de3b36a492542a82748792c09d72a91e3461",
  "ec028dd3a1141cf402b1ed42d1e5ae7bb7332bb0",
  "f1e7332ce70db9d9fa4e44d3808a6d55a990d951",
  "9b68706b338b4d572e8b476a9e9c381819d0f93b",
  "7f334665f0043441d5887b5e01c1d8076416d889",
  "79c0a40e4ec8b8578873cdd8ba38120158da9eaa",
  "07da61842f1d9cbf40f54ad3ee5a74cdbb44e15c",
  "e121acef8539615b8dfbfd67f067ca71fd642ea1",
  "09248759ae6f0707a779782c6b533ab4fb2f6179",
  "200dd5083d54f511081680cffbe766fa00019dd2",
  "2f13603ffc230aa983f55de704233965e8599f4e",
  "52b306b7b4993c8388761808269f0ff25b088323",
  "e6f48eb8f5aac280c720042bdab9826f79f6d591",
  "7f8ff4474cf8ecef53344649d7b74d69d8a4c552",
  "c4fae87d5dbef75236163b366898c3457745d2bc",
  "c652a1fc685ac6ad37fe31f56c1c035fbea680d2",
  "a49190c63b8ed8fce952c8a043dd22601e0137d8",
  "c56a541e368165492e87d0914e83905560411457",
  "71aafc68af1ca23e67b3f7da5fb2dc895d2d9317",
  "65784a2c8296911f36e0ec872a53bb004f908d0c",
  "9b395f89c341589e10278e31d9468e197963234c",
  "7f85c28d8e76ab9302c61864f5c8739f168fb2a4",
  "593c15e1d0b63e138facb816e4ae1f453d8b2bb5",
  "44bc74a561284c543f174584a2a3e4274c20cf60",
  "1a8979a6c3e03708961a8743f44d9a8f2d224530",
  "eb598194ea559c98ac599c17db33c2fddc01d88f",
  "241a395cbf5c666cafad1b5ba07c7fffbf81b50d",
  "acb60b08d08df5fdaef2993709646c373a4c9ced",
  "d44e93119737ff4beac69d6bfed0a5f0e6af5f5b",
  "4d8e43d43112751e53d6efc97bdf8ea16dbefce2",
  "37cd6b8c9fa6973137a69d062ef013246df244e1",
  "9e846fa3fa5f600efc14c073639a8bdadc626167",
  "3c8de6265198046042fd64c13ad8663fcfc06f0f",
  "c92fb41beb8bf91479fd30b42a674aedeb48a66e",
  "1ddf97cba587ee9d028ee5ed04d31c1a9dd1349c",
  "5b34e2461fdf0b2ff446aaafe6fec0b2563e8e96",
  "f8fbd09eb893c581a7eeaa7f9087a7623f4bf6a4",
  "21554f2b51b876752276833d39083307d2fcb6a5",
  "1fbcdefbdd4e19ae423d9ca805de6209b6259174",
  "38b9fe65a15d6eeac4af3f57e46766e16b2401e5",
  "b47d32e5c726adaa205e0a6b4f4d19b4b87555cb",
  "875c639d21852725896e98c28752ead260f0a2a8",
  "fd14c691ad02b210c77dff35039d65424c0b9445",
  "e285edf3c23cc5c25ee50e2609e954d8c79d9b7e",
  "6c82dc4160cce82582191f329d1c8ecce20e7d22",
  "a51d844c77edab7ab0ba7cafa2869f0fd130b589",
  "636edc8316c532d3fc54991bf4769e297601b3c6",
  "f6f8b77eda83fdc7fb5e2eefe8f64dec6c616a0a",
  "f99b96abd5534e3ed5c69c5d9b014646c6758303",
  "3c528b9b797a88db9ad5888756901fc5e41ef8cf",
  "25075e292afd4a3df98206341595adda9dca147e",
  "63a27e3b06e85b98466741379a8fb8408f36bddd",
  "191e15f63f0c57f35df8dd4e7a8a12f045fb31e9",
  "f3e6751f567177bea5c826f85a4577fff855a4f7",
  "c59bba656f4ce178b56d6cd21a03ce4c8afa650c",
  "9a425f76d045cc6789386a779a9cdda12b661293",
  "1701f405b9ea1fde1379d0ad5fd5f471883d47dc",
  "2da94d4277197fabb6588123f14157f0c93ac7de",
  "15ffc0fb0732fc8a7eb466038f1650bb5ead1d04",
  "d2070101dab83f537a19eb5c9619bdb39eb4bc08",
  "2e01de1ed36c0ec2d0aa7eba38908d67e2caba92",
  "eb97b5e0db89680eb7dfbaf5a66753cda3a06bb2",
  "cbf49d738c437bdd68eb6e4495ba195611e92c96",
  "53ee38800deb0f9132d504f402eb0d8f2d7125d0",
  "d6099388a9b1e2ff2a34f6abe8f4428d3e0620fa",
  "34b61a38f9548c9f91239b270b54ebbfcbdbd6ed",
  "38a5c169e1b6c95a229f0ebfccf31f3d23769b03",
  "8df75719159bd4e1be4f9a04d3f3e88b579db290",
  "2d80c0f061d2f688d68aff379cfadb2f5cd90c8b",
  "3791216d361c6fdb681839e33fd4042b2f59f8c5",
  "06da7034ff33302ba8181b92654f0a691da8fd11",
  "691cf966263491588f71bbe9d8a4b0cce8abde1b",
  "fd1d8534990b5fc1279c32d177edf539b1edc06a",
  "b576da9336da7267cc5571be768f1a7c9b4a473c",
  "04ea1f2fcfbd9c82bff58b7219044d9da73f96b4",
  "df1dc411e15e5a971cc877a8cf2fb4effc19341f",
  "8dea54bd2b0546faeb14c2cc6c4728e87e6d9401",
  "413948254f1c1d85a5303d14f7be640a217e14f1",
  "9913f93b1683c7338dfd39f8dc23b1c7a4869a72",
  "56fa9e2a764c34e6f55c94231c7ce01ad2819953",
  "56fa9e2a764c34e6f55c94231c7ce01ad2819953",
  "1526286a01bcec1ffcac077e690eb089dddbbf9b",
  "07eb5c1464c00d690df0218d51c5ddf694a8d2ef",
  "1a6023c08b854a674059f9ad375cd4647a141f89",
  "da71c6f5cc1268a996c5bd72d700042efd69bad7",
  "44ac27bc9db3f408c5de8f2960ab41e86beeac6d",
  "2fe814b30c0d616310a214aab91c9bcb84e09f87",
  "7ae4e067422123a46973bf6371f5fd2725097103",
  "c2f8e5104d2cd3eb9d7d6d3349c7441ada001e45",
  "05b3ded0e8954817cf1e1091ac19aa477121c130",
  "9292c3f5660dfcebb6cc1e0e694d845d9c8f1894",
  "4792e0d0c27a244bef2d995c73f5e591ec07613b",
  "3707421fd69f5fb5087d175cb95eabc5a09c4dac",
  "f24b3823341c4a6bd013baf7794e880f647f65a5",
  "5be6ef8d923691114ae56f3643af3a3f8f772e71",
  "33031c98c4f2dc1ff4cfb377714395570fbdc8b6",
  "e31ef83a966301842d90d977feb4613fb9b4847c",
  "0ac1eb55829bdcfe099dabaa4326f662531d48fe",
  "599f1bfaa42396a0582ca91a33e2a7fa1be23ec6",
  "f87dbf4a11e7298e0c2798b87e061e7e061770d3",
  "9ad0d38b909749459a97003bbb58140b3b7dad0b",
  "d6c7349d1d0d65a0e8be79199329f391ffe1cb4f",
  "3c9f07a47fd752076baaf0425db404afb031aad8",
  "f7dae2da86be018c478d92fb8042398f8df27c4a",
  "fe473e10fa9135d2a3ca904fbcb5453e78265e71",
  "ed55706370caf9103e3bacbd393971d14d5fd0de",
  "e680faa17b95ff56682eaac18bbeeb042d13d6de",
  "d68e488321894bdf862a20e4d3943492288e97bd",
  "c06af11395bfa5caa59338c8be92b9c1b2779b43",
  "2f7a2267902f2e9627102721031570011c187343",
  "9a87dcba4eabe68314d90c51977d899b6b732276",
  "d541e2ff2cc7af0ac862629910b3473d2f478128",
  "7e976f175b4e73b652afefb8ad13a3d39b6494c5",
  "ea4dc55f7ab3d1a6a4f34ad448cab889c50d6565",
  "ab0ca4b705bd3905b43d57639977470780dee266",
  "a68fabcc6ac7eef224f6cf99c56991876a4208e3",
  "b8393f75331b196fd36351c86fc2c37c3aa1e237",
  "02e750df02514b678c7d3aa98f11924a8a028216",
  "66f19ab69a1616422af7fc831474b6567f47c3d1",
  "778bc189d3373949c7bea164ffa0880860300b13",
  "ca2229e241ac9c75f086f5f449317d05881a729b",
  "0a54deab1a013290221f0fe098bd88e761341738",
  "34aa7927a0b4b63a3d98ca46d5a6cbcc18aadf0e",
  "c82e811f5de2e7367fd947c18a8edc2407b9dedf",
  "b7e623d5fed7eb8d951f41b0ead10123a6b2825b",
  "6093dc19036b74f2a026e5d1c897d69001da6866",
  "6fd2dc88db999027c62fac9a9187250959fb1563",
  "46045b145fcc96a5a8ddd6abb385d2553fd52635",
  "699f9044f82b6453d8f21b6dc247520e2e0457dd",
  "d18c6382dc7ff72671902b49d63aa8baca827e44",
  "eff4690dd6e311e3738b77d9c9fe0dfb11a17a70",
  "8f69c7223ce0b68f3e5667e7243dbefd403cf64d",
  "a627e210db19fb4e1377d53cb0b31095222c1954",
  "f67690468acb39306cb145a752ee527744aeadcf",
  "8134156a650d98a9ff0f14695b42a443b8732339",
  "47431898bfad547a58cef63962e89efcd627b62e",
  "6077a394ff29446f6e8b66f2caf8fdd44d8c5a46",
  "439437077ef6e490ea306368526df0322576641b",
  "1b41f8ee387a2e821e50ff09ab1daf46e2d29444",
  "ca04a67b887247249b8b703065ebe2a2690168f7",
  "6802a66f9b48cb390c37547288cf71a68a8e068c",
  "08f892f28e2c2ae4d637f027c7d236370e8fdb70",
  "84ee4fa111a64b191b3c2d080efd46116cbe7428",
  "2cfcf05e6730162039b4f9a0a9e910abe75edee6",
  "7474f4b9f55d76314c7597eb8f58c638e29f6c9a",
  "9d33ffe152c7b4c9be0a4e8d3eecda4eb25cd76b",
  "a35f508a94b8c1b9e01dd54dc3c47167273bce11",
  "016443f8fa90a2194d0a31a44ccd43a231da305d",
  "5642b797feed76fd7d88dffc1696634e9b3cd353",
  "2a4dcaf3b0b14265c66d32a47b090c5a144f8890",
  "8eaea9e7d649c44c0533dc9f93e5d71f49a5f3f5",
  "01107ce6fc5fb996dc5d3dbf3c31cefce8605e50",
  "22bee96b09f3ebe81fa9217dd8d629603a2eb5c9",
  "b4ab5a3561c04990eb81196b1add340b90823f5c",
  "ee65410cb189b175d5670527db3cae5b1923250a",
  "706e904b52e5963e265db500fd835d00bfc79cd8",
  "e4ce520fcc29a8b40a12c217b7438934aaae2c89",
  "f29b7f15688beb6f280e031f1a67598c1f2f3e98",
  "cce8278869955411237748ab41eb6bc6874520b0",
  "44b9d096d6ad34cdbd1e1ec9ce6c1a09b7f52bb2",
  "6109822bc55ce87f628c7afebe01fe27823914e0",
  "f148f6583e27d9c9725b9e871770337bde05629d",
  "8b491f086fbd421cebb41a51b2af996f42051153",
  "0cf1b8a65ecda42f1befa42b0b19381052f13e3a",
  "cb97f2ac9355fb4689c472cc821294952982c35d",
  "7032dab3cf802d85074ec6701c0d16b51266436f",
  "79dfcf1bde11320dfcc7c31254899391ea148759",
  "3d9c31cc07a766b33a29bc9350a45d1d3c8a5f2b",
  "e4ce50e095f5a2b996da37454be95c24e646fb21",
  "2de1af607c2ee4dbc87d139519eaa93795a91287",
  "a319325fe8323038e04b9d95bcd15270a473f081",
  "733fd6a7a3f046955f88a19585915fa6dc7cebf8",
  "81ce2a6868095bd1cbbd87bceea4ce7af289bf19",
  "09642ac27cff47553921ba3b3cbd40ab7e5408b2",
  "aed00198279ebf9b41512ea992d44aef97b29f0f",
  "c582c313ebad191300782763f2bf92ee3fa41667",
  "63fd9acab39f5f05349d58abbadd0138525b1cba",
  "d78f492ab6544985a6516e583ad562f13efa5289",
  "b30e8e43e3781b78549415abeb3ef86c337467d7",
  "7b496a504a74c9a36ac7c672d8d2c9d60ce38ebd",
  "04aaf7e61aaa4365678b6c3721d79e7874d7eec5",
  "dcb5c54dbce15d78b6a9fae5dbc7918a2e83bb0d",
  "ff4b6813fe74126ec737a8f1f6a8580c0d52bdd5",
  "907912bae5f40e93c1ff5a5b24f70a849c328c7e",
  "a84cd2ac89fe25bb1c70151762df8fe81fb77b22",
  "38c0931fb22e25a0255d8bcc5005e1d426032d99",
  "127b2acef2558a624f285ddb8745ada8e9bc4d9b",
  "141b6897f5b4831d90babe6106d46e7e72286322",
  "9b51639689fe1d79ea5e6b75eac6a3631ea10488",
  "04da076bc68002bdabb5ade79055f88c2931e689",
  "d4a08c2f6972834e9a973c2bdb24a9c5eb35a961",
  "c6ffa52abff7c4435bc539dbff3b54ea077b79e3",
  "737ff4173894d90241fd66c439e2deb2187bc0fe",
  "52c26c658f8dad883cba6933aa9357e485fa127b",
  "1f385ae7f75e9157b7455b30e67609f23740138a",
  "483e9b0573c295a12de58504875a297bc31a571e",
  "832a415a20506b8659c40d968c46d10588c807d0",
  "cb5b9a4ac15f228cfe3b0858ba441274667b8999",
  "3597b83d390edcbb1a6f1b012ece79663f2aa5c4",
  "2a6abdcbf04156925451db975421458ab8ec73eb",
  "a1c0b5e5d4b203a60f28a438290515c56b4321be",
  "9ead49341f9e5443a1115bb01ecaa86fb4337c93",
  "d8a9d92923b705301fdab67ef59d986fe244e5c2",
  "15f48ee9160038142e000a14af917ebdb30c2a8b",
  "ffadd32a0448db5fd962204317a52debba124292",
  "bd2039a4aa77674468c7cbb901b555d508662e3a",
  "518da6e1f69629a53280fbc2a8222b6f567eca4f",
  "b86f4ca312208bdfd64c5b3785d86162ea9fcb52",
  "443d146b805a4f7155bfb8716bdf1eee258e72ef",
  "5f1c7232736d304912a6f90adbd7494edf16089f",
  "8fd58975bba72a65808508b36d5cd28d39e3c064",
  "9746235964c26fea621170d720fef5ffa39b7365",
  "3f6b9bee3fb137e52bb3032cb871e07ec3ed5709",
  "92c8fb676cf522c118408cc8fc48745f404911c7",
  "0ac855919aa0474944514af66f01c4c13b81a43f",
  "d6846d4eed6c34d88558a8cf5b45c020561d93ad",
  "b270ed57c41e6565059272792768f6770b05ead5",
  "e59d8844e557b84a2294188debee2299c30f94ae",
  "67ba8c9c31df32cff29e63ee68964cbb9b759641",
  "d7a6a8ae63be78b7352640b4cb211223a6a1314d",
  "b0214c9043b3cd0f1545e891022e8e94c874f89b",
  "fbc2bb316a0edcb19cff3715d26c2a2703fcdeba",
  "3e7107ef99596b3964895f52a94ac80a201e2078",
  "8dd5956bb06fe2fdf87689c72d4b34a9903e8e96",
  "d8d8e417de002212cafdf47f505cc4ca848ac6b3",
  "d29f726bc6514cb16e704ac363711b18bc2cc3ba",
  "e3618e0c44e86bb20624c9b312e6bf293a6cadfa",
  "9e6df3c3f5c70e6bc47a6905803422b870abdffe",
  "059242315480dd84bd84d0f90ca1d1ccda1edc35",
  "7a44707e40530be2caea83447f964cbde1f927db",
  "05cfbd2576d6b463b08b1a6e909fbc5d4ed0eb68",
  "3da547b46e1b7c9cd6a6d96c99106b48ce672417",
  "654b8a33c5e6f4c6e7c1a6b2634fd70d1c491359",
  "75cc5191af6aa7fc1c1f37f7e1a94bb59b527f07",
  "44b4d6142546caf47153ab23be900914ee6ba171",
  "1002c919895d56dd8d4b945ed372bba940fc916f",
  "92ed43fef31ff310dae22505373ef6499bdcf785",
  "384bed499d8c1a3b03ce27e741d2408c18fa2003",
  "a9319d003279fe32b06a91f93b4e270ceb47af17",
  "39338de1c377ab8187d66aef0e0b0dddbc59f19b",
  "f9baf936aa78a0b6b425cba179d3353a2b92b9c0",
  "dc888b7b39700e6c4b1bf346fed355d8d573b243",
  "85c543cd8bb680e67666a116cb17b64c8d2e4f06",
  "ea76bf4b55307d25544ea9c42b5107a27f58f3c5",
  "4928e7f7304796b0191139ef74e228a67e1ff337",
  "0f4d9e25aa1147f9b361df9d3fa9037f6c35d405",
  "2ef1aed3466c54ab79d85b40ea12347a555a9606",
  "9326032eda6ae5d68ff98df9e12a517bbddbd8b9",
  "51510a6bd5f1c8fb5462d4b24f0691b9fa02fa1a",
  "56fe9d83b2a0636396254b5da6c228b267006858",
  "610b552c2e1a177596e9917780acf5abc6d9816d",
  "7a845b08103aa715994d3946fd7ad642fc5c2c69",
  "25b79293c74800e0a9d704d0816737df4f0f442e",
  "3f39d9ad1d30eec15f6f4f4a1fbd7339b26f715c",
  "34e18c31576f153529da6e872fa39c4712582e78",
  "4e1b12ac776a87e438886d68ae35fbd1f963ff47",
  "195752eaf1d966ac777607c117c0a641de5a8f77",
  "de1b0d49b1f86987983a97adf6dda9548fef3c0d",
  "7a551d894e965c00a5d461f5a692fa39635e7a17",
  "d7cbe278b15a3084a602801fae247a8542dcf38c",
  "82951c59b9538740b06f7e0d17faea4b56deaa40",
  "a2116d246dc56dd3d32a79f1ccc0276b6321f3e7",
  "a8a5d83d8ad92e79b8eaf5b380608b9a01c23c5f",
  "a0a0e2eb6a44e332a1d0ce1c7a5056b6152eaa71",
  "a3bcd50d37bccc93479fc23d8a70569674f69d73",
  "1a2ca120c06767ec742089efd2815c1fe5c25728",
  "12525cd629fcd8f92d5f6d7c34ab0ae29f8cd3b7",
  "901aa1a63be2bcce4c972f6ac7f531d212ed11d0",
  "89bfe9fb880fd110f0f69076255dcf672acb1081",
  "cee449402d2cef6a9e7c580759edcf6ec4a6634a",
  "585d42696f9f125e0a1d7bbb3d34e279ac3eee8f",
  "97061413406146d0585ab870157b0e735be37873",
  "374215e82f03d7ee1f42019a25297662c5c2b826",
  "a426fa8140ec3a50309593db3c795aaa66242b9a",
  "6b4ffbf8b75e1b0b301150331bbf859b7d1769a9",
  "118fb919d4f74a06ed16ba9d46ab2d4786549868",
  "b358d4e5387f33165f87f83869a8efb0716ce48b",
  "8dd1e4e0682407e0b07c4b3d3bdd912151a638c3",
  "51abb81af0a9fea8dded8b6660ffe8fd4c5f8224",
  "5513a59a3f72f0d7e2ffeef576e245ffdd86112d",
  "f1ca0ce13aa982abb72a7528e352d9e5c61b401d",
  "66b6453d280770d965ffe2a9b996acdd1678f3a3",
  "9ddb74ef5d219cfe970c9768d11cb8a266d89df2",
  "5fcb6d0c501e292b13eae626215e56db10de6bbd",
  "2c51ffe19d30a73c9ee2390541ccc41286a0d747",
  "bce9e92b1df570bc90847dde471ba0fe5f48ef3a",
  "06ae439dd32517ddd90cd8076c8e577438666b9e",
  "5712945cb9d96e01cd0b6c443b8cffb46c838b1e",
  "bf53fef6d8d0d3c59a280ee53d20444e086a81fc",
  "9419697a076747238fed3d50fee8fd92056325ed",
  "85df8e1b985354a96f34f6997e0d2707ed542604",
  "dbc1f64f9997c677f3bd2dd03050b430f6d04674",
  "cde4e7ba8c7450eb3112f322c4419eb39ee76cd2",
  "1ab0fb022e51ef5e3e9a06fb99b15ec7d0ffbeb7",
  "a8713b943f0cda210d1861eaec2d418c22044ccb",
  "84a6d491fdc5feb30f102c5a0bf2b69a31910c05",
  "03daa06c878a3689b5617e65d38ae40704a6d9e6",
  "64ff2177a8022b638b23e870a8f0230d93544b5f",
  "8736ef26517bf78db62d0a2ac88864cb4bf2ceab",
  "e134f8688afc2218fd61ce6ccf70e754eaf2b3d7",
  "d781f7d5862583168a0d544ca297214ff174b32b",
  "c34815e41327a664f86ee6ea2c966aa6e2b46dd8",
  "b4d71b4321a1f89ccca0c2416dc78375d8dad8ce",
  "f67e291e42e021c276be547ff3de868bfd14cd81",
  "49811996b370b783822a9efee55f9b7dbdf5942e",
  "a8d82f70d370ad342ff9d8964c1b453f7d83d5ea",
  "cb0583243d4a0f79973dc26b09cc73136b10e079",
  "c11fa8130ec252b4692c5b1e49a8bbee7760f065",
  "e0bbff89f0aee99073cb8da20dba323afc329d39",
  "76fdc175020a65c63b64010e9f1d84ca34de4a40",
  "6b3e81e3b5f1ee5820998ee4ea294c396529f448",
  "dfbe8d8ce8749b08762e71d6a2517a62c79079ed",
  "0845c94d008399b9288e3ddae48fd11aa9832b85",
  "06aee9aa414a1dbe59cb83f7c214dcfcae03c202",
  "d2afc7e0c0e846f96c1fe318c72a83bc32f8d4ea",
  "9d6875cd5cd4e31dc339018f9cd1515a2c54a037",
  "bb708cea910c2d377d51e68f970428b7cd4869e3",
  "f25a154e1119c46c9dac473e649fc397b402dc91",
  "a317c21e18e9e6cdd5054c413f17b28b951e1f75",
  "970815e9e26656777ec14907f82320cf02e500d1",
  "ffcce7098d6d5ff020dff388cc9aaf22d01bd0c6",
  "6344848bf2910e20ae50cd2b4474003fb0c62093",
  "5a5abfc873a4aaa64dc501579acdbe330eaafe34",
  "fffc62b27bbad7815aa9cb2509fd49cef5ab5301",
  "8c075856908a358c7711d79d0b72fee0e55fa76a",
  "e8a847d0c999da42f780b5cd913895f0f688c20d",
  "8b7a7793b6b95fad0db0ce0769edeba2482f1df2",
  "556e82907a1fc98c853e0d491a9f6e39b382675d",
  "5b6e78226c9b20aa2ab4523d915982a7a76dcefc",
  "4ebedaaf0b83d321a45e7cf1aa674e21d3d6f348",
  "129413cded8e63e51afc378fbf6450e65eaf377d",
  "61eef0de9f245954a1ab320d9a8667f6214f8209",
  "363355bd8e482822b3203504edee684a32a4dc96",
  "5992f06218e1f761e3c6f6702bb59f4f6e5b3b65",
  "cbceb345584940ec7d6fb404d2b2a1650d71341c",
  "e81d2a09ab842476905ab0e01f906af4ce30449d",
  "ba78c57eaf8961a543bd277fecaafb65cae7236a",
  "bcdef6311222a07abbd1e6fcc5134be145611655",
  "753e063b3c89aea331ad30f2acfffc2172a93068",
  "478a78bc257986a994485f15561215a75066a8be",
  "21b76502ee88e178b993cdbae99b25eab4d47dde",
  "502b6b30eba6762c91d141da3290cb8be1027cee",
  "21848e28ea1b5751af641f6d63c0878e6f65be84",
  "8be183db02aa56a1fa6a9fa18dafc9e88b241a44",
  "4e1b3056bd02a7757e3793614ce8f567745d9a25",
  "7a462dc920125fbedd69f89aaa81c290b912f766",
  "fadab633a17dce7f38cd9d7e2c63b158dc4602ec",
  "929048598ddc664e5068cfcf67d417c98442e9de",
  "9d44d50f2aef5b1108f20d6bdf8e04ed5f1b9513",
  "152490611f007e21f9c5343469edb24428d10779",
  "e23cdfc2058d0e9502b6a9a263482de28e8f577e",
  "049520d97970bf4893b3834cc419ba6d9c2eb2a8",
  "f308b8d681a85e1cc13e7cf596316bc372971bbe",
  "e38c865f00b3e8d113d434b0b63b8d6ea4a14c38",
  "213012681ebb268ede8786db65bbffe2f6e7e233",
  "77af5cfac7102807cdc6dbe95b581ed122c1700f",
  "3abfceda96f4717945739d077d274f65af2292f4",
  "a7eefcf4d04e70eec018eedb37cd29f0d27cadca",
  "e04c98ad728309214429f2b437513f5b7d7f6079",
  "0f0abb306256351b8bbfd1829be5310166eb5fab",
  "b55728285dfb32b2b26729e64a53e3efe56535b8",
  "4de9f605f7899a8fdbc1d166f7dab2624d70b75b",
  "24f3522818fb9146cb3d520f34bda56c6f2e1cf4",
  "da190839bb98f1ff7e71b56a7b7659c416a17bfe",
  "33db4017a3ed69f5117f43a2bb67badaf270b113",
  "f94cb5dfacf4694126acee93a8de3335466b662d",
  "7cfbd0365e3c3467d1662572c5aca4419ac0d69d",
  "d34ef1dec8cd039cff901a7f9300944931940c2e",
  "2423151c11bf422f062ea2f9bef8e6fd7f920dd5",
  "10a9efb671bb7aaf9a565f2a0efd05a04a4ed72a",
  "f34c6f04ce11a4293fb6fb9de8ff760f2dd94233",
  "b41a6f32c899f49d67cba1fc71367506bb695f66",
  "6f8c1139cc1e387d5969093c5bd04775c76343da",
  "d2ae405460107883b28fc0fc4f9585e3eafdc112",
  "b336a261342b0da0f01582531edbdc800e344a67",
  "f90b0a51435afa4ae4e09835421ba960dddcb28a",
  "3af8d922252008b56f1fe9ba9e019c9dcc84880a",
  "459a1f17b8c91bc4fcbb13e67771aed2a5db63d0",
  "c12d6ae9879982cce7d7b4ace2160176e5b21154",
  "b2377a3f29071b0b4db78faf060539ef831b69d0",
  "42ccf2f2a4ee636493196dbe0519a4c77727627a",
];

export const passedBlacklist = (
  message: string,
): { passed: boolean; badWord?: string } => {
  const messagePhrases = message
    .split(/\s|,|\.|!|\?|-|_|#|\/|\)|%|§|"|'/)
    .filter((item) => item !== "")
    .map((item) => {
      return sha1.hex(`${item.toLowerCase()}${process.env.REACT_APP_BL_HASH}`);
    });
  const blacklistPhrases = forbiddenWords
    .map((item) => item.trim().toLowerCase())
    .filter((item) => item !== "");

  for (const blacklistedPhrase of blacklistPhrases) {
    for (const messagePhrase of messagePhrases) {
      if (messagePhrase === blacklistedPhrase) {
        return { passed: false, badWord: messagePhrase };
      }
    }
  }

  return { passed: true };
};
